<template>
  <div class="main">
    <HeaderBar />
    <LeftMenu />
    <RightButtons />
    <Legend />
    <SessionPopup v-if="_imin - _MIN < 10" :countDown="countDown" @extendSession="extendSession" />
    <div class="content">
      <div id="mapContainer" class="map" />
      <div id="popup" class="ol-popup">
        <a href="#" id="popup-closer" class="ol-popup-closer">&#10006;</a>
        <div id="popup-content">
          <table>
            <tr>
              <td colspan="2" class="ol-popup-conclusion">
                <span id="popup-conclusion">Exceed noise critria</span>
              </td>
            </tr>
            <tr>
              <td class="ol-popup-textheader">NSR Name</td>
              <td class="ol-popup-textcontent">
                <span id="popup-nsrname">ABCDEF</span>
              </td>
            </tr>
            <tr>
              <td class="ol-popup-textheader">Max Unmit CNL</td>
              <td class="ol-popup-textcontent">
                <span id="popup-maxunmitcnl">70.909090909</span>
              </td>
            </tr>
            <tr>
              <td class="ol-popup-textheader">Max Mit CNL</td>
              <td class="ol-popup-textcontent">
                <span id="popup-maxmitcnl">70.909090909</span>
              </td>
            </tr>
            <tr>
              <td class="ol-popup-textheader">NSR noise criteria</td>
              <td class="ol-popup-textcontent">
                <span id="popup-noisecriteria">70</span>
              </td>
            </tr>
            <tr>
              <td class="ol-popup-textheader">Building name</td>
              <td class="ol-popup-textcontent">
                <span id="popup-buildingname">abc</span>
              </td>
            </tr>
            <tr>
              <td class="ol-popup-textheader">Noise Contribution from Neighbor Site</td>
              <td class="ol-popup-textcontent">
                <span id="popup-neighbor">abc</span>
              </td>
            </tr>
            <tr>
              <td class="ol-popup-textheader">Max CNL with Neighbor Site</td>
              <td class="ol-popup-textcontent">
                <span id="popup-neighbornoise">abc</span>
              </td>
            </tr>
            <tr>
              <td><button id="popup-mitButton" class="p-button p-component"><span
                    class="p-button-label">Mitigate</span></button></td>
              <td><button id="popup-distButton" class="p-button p-component"><span class="p-button-label">Notional
                    Distance</span></button></td>
            </tr>
            <tr>
              <td colspan="2">
                <table id="popup-listtable" class="ol-popup-listtable">
                  <tr>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Total CNL</th>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div id="popup2" class="ol-popup2">
        <div id="popup-content2">
          <div><span>Northing (m): </span><span id="northing"></span></div>
          <div><span>Easting (m): </span><span id="easting"></span></div>
          <div><span>Double click to exit drawing mode.</span></div>
        </div>
      </div>
      <div id="myNotif" class="modal">
        <div class="modalContent">
          <span class="modalClose">&times;</span>
          <p id="myNotifText">Notif content</p>
        </div>
      </div>
      <div id="myYesNoNotif" class="modal">
        <div class="modalContent">
          <div id="modalNotif">
            <p id="myYesNoNotifText">Notif content</p>
            <div class="formgrid grid">
              <div class="field col-12 md:col-2">
                <button id="yesNoButtonYes" class="p-button p-component" style="width:100%;"><span
                    class="p-button-label">Yes</span></button>
              </div>
              <div class="field col-12 md:col-8">

              </div>
              <div class="field col-12 md:col-2">
                <button id="yesNoButtonNo" class="p-button p-component" style="width:100%;"><span
                    class="p-button-label">No</span></button>
              </div>
            </div>
          </div>
          <div id="modalInput">
            <p id="myYesNoInputText">Notif content</p>
          </div>
        </div>
      </div>
      <router-view />
    </div>

  </div>
</template>

<script>

import HeaderBar from '@/components/HeaderBar.vue'
import LeftMenu from '@/components/LeftMenu.vue'
import RightButtons from '@/components/RightButtons.vue'
import SessionPopup from '@/components/SessionPopup.vue'
import Legend from '@/components/Legend.vue'
import MapOL from "@/libs/myOpenLayers.js";
import CryptoHelper from '@/helper/CryptoHelper';

export default {
  name: 'MainView',
  components: {
    HeaderBar,
    LeftMenu,
    RightButtons,
    SessionPopup,
    Legend
  },
  data() {
    return {
      _imin: 59,
      _isec: 60,
      _MIN: 0,
      IDLE_TIME: 0,
      countDown: ''
    };
  },
  methods: {
    getIdleTime() {
      let props = this;
      var _minute, _sec, _nmin, _nsec;

      props.IDLE_TIME++;

      if (props._isec - props.IDLE_TIME == 0) {
        props._MIN++;
        props.IDLE_TIME = 0;
      }
      _minute = props._imin - props._MIN;
      _sec = props._isec - props.IDLE_TIME;

      _nmin = _minute.toString().padStart(2, "0");
      _nsec = _sec.toString().padStart(2, "0");

      props.countDown = _nmin + ":" + _nsec;
    },
    handleSession() {
      let props = this;
      // On Mouse Move
      document.addEventListener("mousemove", function () {
        if (props._imin > 10) {
          props._MIN = 0;
          props.IDLE_TIME = 0;
        }
      });

      // On Click
      document.addEventListener("click", function () {
        if (props._imin > 10) {
          props._MIN = 0;
          props.IDLE_TIME = 0;
        }
      });

      // On Key Press
      document.addEventListener("keypress", function () {
        if (props._imin > 10) {
          props._MIN = 0;
          props.IDLE_TIME = 0;
        }
      });
      setInterval(() => {
        props.getIdleTime();
      }, 1000);
    },
    extendSession() {
      this._MIN = 0;
      this.IDLE_TIME = 0;
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    getCurrentUser() {
      return this.$store.getters.currentUser;
    }
  },
  mounted() {
    if (localStorage.getItem("epd-cnmp-user")) {
      let user = localStorage.getItem("epd-cnmp-user").startsWith("{")
        ? localStorage.getItem("epd-cnmp-user")
        : CryptoHelper.Decrypt(localStorage.getItem("epd-cnmp-user"));
      if (user.includes("[object Object]")) {
        this.$router.push('/Login');
      }
      else {
        let userObject = JSON.parse(user)
        // if (userObject.userType == "admin") {
        //   console.log("here")
        //   // this.$router.push('/Admin');
        // }
        // else {
        MapOL.initOL(this.apiEndpoint);
        this.handleSession();
        this.$router.push('/Projects');
        // }
      }
    }
    else {
      this.$router.push('/Login');
    }
  }
}
</script>

<style scoped>
.card {
  width: 430px;
}

.center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, 0);
}
</style>

<style lang="less">
.main {
  position: relative;

  .content {
    position: absolute;
    top: 70px;
    left: 0px;
    height: calc(100vh - 70px);
  }

  .map {
    position: absolute;
    top: 0;
    left: 0;
    width: calc(100vw);
    height: calc(100vh - 70px);
    z-index: -5;
  }

  .ol-popup {
    position: absolute;
    background-color: white;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    padding: 15px;
    border-radius: 10px;
    border: 1px solid #cccccc;
    bottom: 12px;
    left: -50px;
    min-width: 440px;
    cursor: move;
  }

  .ol-popup2 {
    position: absolute;
    background-color: white;
    color: #0a0a0b;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    padding: 15px;
    border-radius: 10px;
    border: 1px solid #cccccc;
    bottom: 12px;
    left: -50px;
    min-width: 210px;
    text-align: left;
  }

  .ol-popup:after,
  .ol-popup:before {
    top: 100%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  .ol-popup:after {
    border-top-color: white;
    border-width: 10px;
    left: 48px;
    margin-left: -10px;
  }

  .ol-popup:before {
    border-top-color: #cccccc;
    border-width: 11px;
    left: 48px;
    margin-left: -11px;
  }

  .ol-popup-closer {
    text-decoration: none;
    position: absolute;
    top: 2px;
    right: 8px;
  }

  .ol-popup-conclusion {
    font-size: 15px;
    text-align: right;
    padding-bottom: 10px;
  }

  .ol-popup-textheader {
    font-size: 12px;
    font-weight: bold;
    text-align: left;
  }

  th {
    font-size: 10px;
    font-weight: bold;
  }

  .ol-popup-textcontent {
    font-size: 12px;
    text-align: left;
  }

  .ol-popup-listtable {
    width: 100%;
  }

  .ol-zoom {
    left: auto;
    right: 12px;
  }

  .ol-zoom-in,
  .ol-zoom-out {
    width: 32px;
    height: 32px;
  }

  /* The Modal (background) */
  .modal {
    display: none;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 1;
    /* Sit on top */
    left: 0;
    top: 0;
    width: 100%;
    /* Full width */
    height: 100%;
    /* Full height */
    overflow: auto;
    /* Enable scroll if needed */

    background-color: rgba(0, 0, 0, 0.1);
    /* Black w/ opacity */
  }

  /* Modal Content/Box */
  .modalContent {
    background-color: #fefefe;
    margin: 15% auto;
    /* 15% from the top and centered */
    padding: 20px;
    border: 1px solid #888;
    width: 50%;
    /* Could be more or less, depending on screen size */
    font-size: 20px;
  }

  /* The Close Button */
  .modalClose {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
  }

  .modalClose:hover,
  .modalClose:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
  }
}

#popup {
  height: 500px;
  overflow-y: scroll;
}
</style>